/**
 * Slash command extension for Tiptap.
 * Triggers a floating menu on "/" with formatting options and BugHerd actions.
 */

import { Extension } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion, { type SuggestionProps } from '@tiptap/suggestion';
import type { SlashMenuItem } from '../types';

export const SlashCommandPluginKey = new PluginKey('slashCommand');

export type SlashCommandOptions = {
  items: (props: { query: string; editor: import('@tiptap/core').Editor }) => SlashMenuItem[];
  render: () => {
    onStart: (props: SuggestionProps<SlashMenuItem, SlashMenuItem>) => void;
    onUpdate: (props: SuggestionProps<SlashMenuItem, SlashMenuItem>) => void;
    onKeyDown: (props: { event: KeyboardEvent }) => boolean;
    onExit: () => void;
  };
};

export const SlashCommand = Extension.create<SlashCommandOptions>({
  name: 'slashCommand',

  addOptions() {
    return {
      items: () => [],
      render: () => ({
        onStart: () => {},
        onUpdate: () => {},
        onKeyDown: () => false,
        onExit: () => {}
      })
    };
  },

  addProseMirrorPlugins() {
    const extension = this;

    return [
      Suggestion({
        editor: extension.editor,
        char: '/',
        pluginKey: SlashCommandPluginKey,
        allowSpaces: true,
        startOfLine: false,
        command: ({ editor, range, props }) => {
          props.onSelect({ editor, range });
        },
        items: ({ query, editor }) => extension.options.items({ query, editor }),
        render: extension.options.render
      })
    ];
  }
});
